
import Hero from "../hero/Hero";
import Intro from "../intro/Intro";
import Bridge from "../intro/Bridge";
import ThemeCarousel from "../themes/Themes";
import { TheWordRevealed } from "../theme-section/RevealTheWord";
import JoinCta from "../footer/Cta";

function HomeWrapper() {
  return (
    <>
      <Hero />
      <Intro />
      <Bridge />
      <ThemeCarousel />
      <TheWordRevealed />
      <JoinCta />
    </>
  );
}

export default HomeWrapper;